import { FETCH_GEOCODE_SUCCESS } from '../actionTypes';
import { creditFileActions } from '../reducer';

export default () => creditFileActions[FETCH_GEOCODE_SUCCESS]();
